import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import SetNewPassword from 'Components/ComponentLibrary/Organisms/SetNewPassword/SetNewPassword';

const PasswordSetup = () => {
  const {
    resource, onSubmit, errors, saving,
  } = useMetaLayoutContext();

  return (
    <SetNewPassword
      resource={resource}
      onSubmit={onSubmit}
      errors={errors}
      saving={saving}
    />
  );
};

export { PasswordSetup };
